import { Meter } from "react-aria-components";

import { INFO_STEP, TOTAL_NUM_STEPS } from "../helpers/constants";
import { usePathname } from "../hooks/usePathname";

export const StepsMeter = () => {
	const pathname = usePathname();

	return (
		<Meter
			value={pathname === INFO_STEP ? 1 : TOTAL_NUM_STEPS}
			minValue={0}
			maxValue={TOTAL_NUM_STEPS}
			aria-label="No of steps completed to get a quote"
			className="tw:relative tw:h-1 tw:w-full"
		>
			{({ percentage }) => (
				<div className="tw:h-full tw:w-full tw:bg-[#CAE5E5]">
					<div
						className="tw:h-full tw:bg-[#359492]"
						style={{ width: percentage + "%" }}
					/>
				</div>
			)}
		</Meter>
	);
};
